import { apiFetcher } from '~/apis/api-fetcher';

export type BrandsRequest = {
  allowDisable?: boolean;
  usedForRec?: boolean;
  usedForFollow?: boolean;
};
type BrandsResponse = {
  data: Brand[];
};

export type Brand = {
  id: number;
  nameKor: string;
  nameEng: string;
  image: string;
  isActive: boolean;
  usedForRec: boolean;
  usedForFollow: boolean;
};

export const getBrands = (params: BrandsRequest) => {
  return apiFetcher.get<BrandsResponse>('/api/mdms/v1/brands', params);
};
